import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  INotification,
  ProblemValue,
} from '@kinet-open-network/shared/data-access/model';

@Injectable({
  providedIn: 'root',
})
export class ShellService {
  protected http = inject(HttpClient);

  getNotSeenTicketsCount() {
    return this.http.get<{ data: number }>('/tickets/count/not-seen');
  }

  getNotSeenColocationsCount() {
    return this.http.get<{ data: number }>('/colocations/count/not-seen');
  }

  getAutofindsCount() {
    return this.http.get<{ data: number }>('/autofinds/count');
  }

  getNotApprovedReportsCount() {
    return this.http.get<{ data: number }>('/reports/count/not-approved');
  }

  getNotifications() {
    return this.http.get<{ data: INotification[] }>('/notifications');
  }

  getOltNotifications() {
    return this.http.get<{ data: INotification[] }>('/olts/notifications');
  }

  getTicketsNotifications() {
    return this.http.get<{ data: INotification[] }>('/tickets/notifications');
  }

  markNotificationAsRead(id: string) {
    return this.http.post(`/notifications/${id}/mark-as-read`, {});
  }

  getProblemsCount() {
    return this.http.get<{ data: number }>(
      `/problems/count?filters=value eq "${ProblemValue.problem}"`,
    );
  }

  getNotApprovedOltsCount() {
    return this.http.get<{ data: number }>('/olts/not-approved-count');
  }

  getNotSeenApRequestTicketsCount() {
    return this.http.get<{ data: number }>(
      '/tickets/count/not-seen/ap-request',
    );
  }

  getUnreadNotificationsCount() {
    return this.http.get<{ data: number }>('/notifications/unread-count');
  }
}
